/** @jsxImportSource @emotion/react */
import _ from "lodash";
import { useCallback } from "react";
import { BrowserRouter, useNavigate, useSearchParams } from "react-router-dom";

import { ComponentPaginationProps } from "./types";
import * as styles from "./styles";

export const ComponentPagination = ({
  pagination,
  className = "",
  css,
}: ComponentPaginationProps) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const page = pagination?.page;
  const nextPage = pagination?.nextPage;
  const prevPage = pagination?.prevPage;

  const onSearch = useCallback((event: any) => {
    const name = event.target.name;
    const value = event.target.value;

    let queries = Object.fromEntries([...searchParams]);
    queries = _.omit(
      {
        ...queries,
        [name]: value,
      },
      value ? [] : [name]
    );

    const queryString =
      Object.keys(queries).length > 0
        ? `?${Object.keys(queries)
            .map((key) => key + "=" + queries[key])
            .join("&")}`
        : ``;

    let url = `/users${queryString}`;
    navigate(url);
  }, []);

  return (
    <div className={`pagination ${className}`} css={[styles.footer, css]}>
      <button
        className="pagination-prev"
        css={styles.footerButton(!!prevPage)}
        onClick={() =>
          onSearch({
            target: {
              name: "page",
              value: prevPage,
            },
          })
        }
      >
        {prevPage || "-"}
      </button>
      <p className="pagination-page" css={styles.footerPage}>
        {page}
      </p>
      <button
        className="pagination-next"
        css={styles.footerButton(!!nextPage)}
        onClick={() =>
          onSearch({
            target: {
              name: "page",
              value: nextPage,
            },
          })
        }
      >
        {nextPage || "-"}
      </button>
    </div>
  );
};
